var React = require('react');

function Captain (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.74 11.5C6.58375 11.5 6.50651 11.4163 6.5 11.26V4.73C6.50651 4.57375 6.58375 4.5 6.74 4.5H9.26C9.41625 4.5 9.49349 4.57375 9.5 4.73V6.15C9.5 6.38438 9.61562 6.5 9.85 6.5H12.15C12.3844 6.5 12.5 6.38438 12.5 6.15V4.80078C12.5 3.88932 12.1777 3.11133 11.5332 2.4668C10.8887 1.82227 10.1107 1.5 9.19922 1.5H6.80078C5.88932 1.5 5.11133 1.82227 4.4668 2.4668C3.82227 3.11133 3.5 3.88932 3.5 4.80078V11.2C3.5 12.1115 3.82227 12.8855 4.4668 13.53C5.11133 14.1745 5.88932 14.5 6.80078 14.5H9.19922C10.1107 14.5 10.8887 14.1777 11.5332 13.5332C12.1777 12.8887 12.5 12.1107 12.5 11.1992V9.85C12.5 9.61563 12.3844 9.5 12.15 9.5H9.85C9.61562 9.5 9.5 9.61563 9.5 9.85V11.27C9.49349 11.4263 9.41625 11.5 9.26 11.5H6.74Z","fill":"#181818"}));
}

Captain.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Captain;

Captain.default = Captain;
